import React from 'react';

import { withTranslation } from 'lib/i18n';

import { formatValue } from '../DesktopTable';

import MobileTableWrap from './styled/MobileTableWrap';
import { MobileTableProps } from './types';

const MobileTable: React.FC<MobileTableProps> = ({ variant, t, i18n }) => (
  <MobileTableWrap light={variant.code === 'free'}>
    <strong>
      {t(`business.index.pricing.table.col_names.${variant.code}`)}
    </strong>

    <table>
      <tbody>
        {Object.entries(variant.values).map(([key, value]) => {
          const row = t(`business.index.pricing.table.row_names.${key}`);

          return (
            <tr key={row}>
              <td>{row}</td>
              <td>{formatValue(variant.code, key, value, i18n.language, t)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </MobileTableWrap>
);

export default withTranslation('pages')(MobileTable);
